import React, { Component, useEffect, useRef } from 'react';
import connect from 'react-redux/es/connect/connect';
import { isMobile } from "react-device-detect";
import '../global.css';
import ParentWaitingWrapper from './styles/parentwaiting.style'
import { Scrollbars } from 'react-custom-scrollbars-2';

import Loader from '../../components/Loader/loader';
import * as PatientActions from '../../actions/patient';
import * as TherapistActions from '../../actions/therapist';

//Video Calls
import { useAppState } from '../../state';
import { VideoProvider } from '../../components/VideoProvider';
import PermissionBox from '../../components/permissionBox/permissionBox';
import ErrorDialog from '../../components/ErrorDialog/ErrorDialog';
import App from './videoCall/App';

import * as DeviceDetails from '../../utils/deviceDetails';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import useDataTrack from '../../hooks/useDataTrack/useDataTrack';
import {getMuteUnmuteStatus} from '../../state/useFirebaseAuth/useFirebaseAuth';
import useParticipantsList from '../../hooks/useParticipants/useParticipantsList';
import * as PatientApis from '../../apis/patient'

// import { useAppState } from '../../state';
const dateFormat = 'MM/DD/YYYY';

const connectionOptions  = {
	bandwidthProfile: {
	  video: {
		mode: 'collaboration',
		renderDimensions: {
		  high: { height: 1080, width: 1920 },
		  standard: { height: 90, width: 160 },
		  low: { height: 90, width: 160 },
		},
	  },
	},
	dominantSpeaker: true,
	maxAudioBitrate: 12000,
	networkQuality: { local: 1, remote: 1 },
	preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }],
  };


const VideoApp = (props) => {
	const { error, setError } = useAppState();
	const { dispatch, patient, match } = props;
	const { activeCall } = patient;
	useEffect(() => {
		if (activeCall && activeCall.callStatus && activeCall.callStatus.toLowerCase() === "on call") {
			dispatch(PatientActions.getParticipantList(match.params.therapistRoom));

		}

	}, []);


	return (
		<VideoProvider options={connectionOptions} onError={setError}>
			<ErrorDialog dismissError={(err) => {
				if (error.code === 20104) {
					window.sessionStorage.removeItem('twilioPatientToken');
				}

				window.location.reload();
				return setError(null)
			}} error={error} />
			<App {...props} />
		</VideoProvider>
	);
};

class ParentWaiting extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fullScreen: false,
			showSidebar: false,
			warningVisible: true,
			showLocalVideo: false,
			
		}
		this.formInterval = undefined;
		this.statusInterval = undefined;
		this.stopInterval = this.stopInterval.bind(this);
		this.endCall = this.endCall.bind(this);
		this.toggleFullScreen = this.toggleFullScreen.bind(this);
		this.toggleSidebar = this.toggleSidebar.bind(this);
	}

	componentDidMount(){
		const callId = window.localStorage.getItem("patientCallId");
		const { dispatch, match } = this.props;
		dispatch(PatientActions.getActiveCallDetails({callId}));
		dispatch(TherapistActions.getUserStatus({roomId: match.params.therapistRoom}));
		const deviceBrowser = DeviceDetails.getBrowser();

		if(deviceBrowser && ["chrome", "safari"].indexOf(deviceBrowser.toLowerCase()) !== -1){
			this.setState({
				warningVisible: false
			})
		}
		// dispatch(PatientActions.getParticipantList(match.params.therapistRoom));

		// PatientApis.getParticipants(match.params.therapistRoom).then(result => {

		// 	if (result.data && result.data.length >= 2) {

		// 		window.localStorage.setItem('newParticipant', "true")
		// 	} else{
		// 		window.localStorage.removeItem('newParticipant')
		// 	}
		// }).catch(e => {
		// 	console.log(e)
		// })

		getMuteUnmuteStatus('participantsAudioStatus', 'videoroomcall-' + match.params.therapistRoom, this.muteAudio)

		
	}

	muteAudio = (data) => {
		window.localStorage.setItem('muteAudio', JSON.stringify(data))
	}


	verifyUser = () => {
		this.setState({
			showLocalVideo: true
		});
	}

	closeWarning = () => {
		this.setState({
		   warningVisible: false,
	   });  
	}

	endCall(){
		const { dispatch } =this.props;
		const callId = window.localStorage.getItem("patientCallId");
		const status = "End Call"
		dispatch(TherapistActions.changeCallStatus({callId, status}, () => {

			window.localStorage.removeItem("therapistCallId");
			window.localStorage.removeItem('patientCallId');
			window.sessionStorage.removeItem('twilioPatientToken');
            window.sessionStorage.setItem('therapistConnecting', "no");
            window.sessionStorage.setItem('patientConnecting', "no");
			if(this.formInterval){
				this.stopInterval();
			}
			window.location.replace('/thank-you');
		}))
	} 

	componentDidUpdate(){
		const callId = window.localStorage.getItem("patientCallId");
		const { dispatch, patient, match } = this.props;
		const { activeCall } = patient;
		if(activeCall && activeCall.callStatus && (activeCall.callStatus.toLowerCase() === "waiting" || activeCall.callStatus.toLowerCase() === "on call" )&& !this.formInterval){
			this.formInterval = setInterval(() => {
				dispatch(PatientActions.getActiveCallDetails({callId}));
				//dispatch(PatientActions.getParticipants(match.params.therapistRoom));

			}, 5000)
			this.statusInterval = setInterval(() => {
				dispatch(TherapistActions.getUserStatus({roomId: match.params.therapistRoom}));
			}, 20000)
		}

		// if(activeCall.callStatus.toLowerCase() === "waiting" && this.formInterval){
		// 	this.stopInterval();
		// }
		if(activeCall &&  activeCall.callStatus && activeCall.callStatus.toLowerCase() === "end call" ){
			window.localStorage.removeItem('patientCallId');
			window.sessionStorage.removeItem('twilioPatientToken');
            window.sessionStorage.setItem('patientConnecting', "no");
			if(this.formInterval){
				this.stopInterval();
			}
			window.location.replace('/thank-you');
		}		

	}

	toggleFullScreen(){
		this.setState(prevState =>({
			fullScreen : !prevState.fullScreen
		}))
	}

	toggleSidebar(){
		this.setState(prevState =>({
			showSidebar : !prevState.showSidebar
		}))
	}

	stopInterval(){
		clearInterval(this.formInterval); 
		if(this.statusInterval){
			clearInterval(this.statusInterval); 
		}
	}

	muteUnmuteParticipant = (isMute) => {
		const { dispatch, patient } =this.props;
		const { activeCall } = patient;
	//	dispatch(TherapistActions.changeCallField({callId : activeCall.callId, isMute}))
	}

	muteParticipant = (isMute) => {
		const { dispatch, patient } =this.props;
		const { activeCall } = patient;
	//	dispatch(TherapistActions.changeCallFieldMute({callId : activeCall.callId, isMute}))
	}
	
	

	render() {
		const { patient, setting } = this.props;
		const { activeCall } = patient;
		if(!activeCall.callId){
			return <Loader />
		}

		let camName = "";
		let showSidebar = true;
		
		if(this.state.fullScreen){
			showSidebar = false;
		}
		if(isMobile && !this.state.showSidebar){
			showSidebar = false;
		}
		let userStatusClass = "";
		let { currentUserStatus } = setting;
		if(!currentUserStatus){
			if(activeCall.therapistCallStatus && activeCall.callStatus.toLowerCase() !== "on call"){
				currentUserStatus = "on another call"; 
			}else{
				currentUserStatus = "available";
			}
		}else{
			if(activeCall.therapistCallStatus && activeCall.callStatus.toLowerCase() !== "on call"){
				currentUserStatus = "on another call"; 
			}
		}
		
		if(currentUserStatus.toLowerCase() === "available"){
			userStatusClass="available";
		}else if(currentUserStatus.toLowerCase() === "on another call"){
			userStatusClass="on-other-call";
		}else if(currentUserStatus.toLowerCase() === "busy"){
			userStatusClass = "busy"
		}


		return (
				<ParentWaitingWrapper>
					{this.state.warningVisible && <div className="WarningMessage">
						<h1>kure works best on the latest version of Chrome or Safari. Don’t have them installed? Download <a href="https://www.google.com/chrome/?brand=CHBD&gclid=EAIaIQobChMIuvq127ry6wIVR6aWCh3I1g1CEAAYASAAEgIxM_D_BwE&gclsrc=aw.ds" target="_blank">Chrome</a> or <a href="https://support.apple.com/downloads/safari" target="_blank">Safari</a>.</h1>
						<button onClick={this.closeWarning}  className="closewarningmsg">&times;</button>
					</div>}
				<div className={"parentWaiting" + (this.state.fullScreen ? " fullscreen-container" : "")}>
						{activeCall.callStatus.toLowerCase() !== "on call"  &&
						
						<VideoProvider options={connectionOptions}>
							<PermissionBox camName={activeCall.patient} showLocalVideo={this.state.showLocalVideo} verifyUser={this.verifyUser}/>	
						</VideoProvider>
						}
						{showSidebar && <aside className="page-header">
						<nav>
							<a href="/"><img className="logo" src="/images/kure-logo.png" width="70" alt="kure logo" /></a>
							<h3>video room</h3>
						</nav>
						<Scrollbars>
						<div className="scrollable-content">
						<section className="patient-queue mt-40">
							<h1 className="section-title">available</h1>
						{/* {activeCall.therapistCallStatus && activeCall.therapistCallStatus.toLowerCase() !== "on call" && activeCall.callStatus.toLowerCase() !== "on call"? 
						<h4 className="user__not__available">Your therapist is not available yet</h4>
						:
						<div className="user__profile">
							<div className="thumb-inner"><img src="https://static.sendbird.com/sample/profiles/profile_35_512px.png" /><h1>{activeCall.therapistName}</h1></div>
							{activeCall.therapistCallStatus && activeCall.callStatus.toLowerCase() !== "on call" && <div className="status">ON ANOTHER CALL</div>}
						</div>
						} */}
						</section>
						<section className="participantList">
							<ul>
								<li>
									<div className="participantList_status">
										<div className="participantList_thumb">
											<img src="https://static.sendbird.com/sample/profiles/profile_35_512px.png" />
										</div>
										<div className="participant_rightpan">
											<div className="participantName">{activeCall.therapistName}</div>
											<div className={`user-status ${userStatusClass}`}>{currentUserStatus}</div>
										</div>
									</div>
								</li>
							</ul>
					</section>
						</div>
						</Scrollbars>
					</aside>}
				<section className="page-content">
					{activeCall.callStatus.toLowerCase() !== "on call" ? 	<div className="call-waiting-msg"><h1>Your call should start soon</h1><button className="exitvideoRoom_btn" onClick={this.endCall}>exit video room</button></div> :
				<VideoApp {...this.props} {...this.state} 
						endCall={this.endCall} 
						toggleSidebar={this.toggleSidebar}
						muteUnmuteParticipant={this.muteUnmuteParticipant}
						muteParticipant={this.muteParticipant}
						toggleFullScreen={this.toggleFullScreen}/>}


				</section>
				
			</div>
				</ParentWaitingWrapper>
		  ) 
	}
}

function mapStateToProps(state) {
	return state;
}

export default connect(mapStateToProps)(ParentWaiting);

